package nl.volleyplanner.api.system

import kotlinx.serialization.Serializable

@Serializable
data class RepositoryCacheStats(
    val repositoryName: String,
    val idCacheStats: CacheStats,
    val queryCacheStats: CacheStats
)

@Serializable
data class CacheStats(
    val cacheName: String,
    val estimatedSize: Long,
    val hitCount: Long,
    val missCount: Long,
    val loadSuccessCount: Long,
    val loadFailureCount: Long,
    val totalLoadTime: Long,
    val evictionCount: Long,
    val evictionWeight: Long,
)